import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    deposit: [
//        {
//            depositSaving: '1000000',
//            bankName: '銀行名1',
//            branchName: '支店名1',
//            accountType: '口座種類1',
//            accountNumber: '口座番号1',
//            accountName: '名義1',
//            targetPerson: 'テスト相続人1',
//            inheritanceBequest: '相続'
//        },
//        {
//            depositSaving: '1000000',
//            bankName: '銀行名2',
//            branchName: '支店名2',
//            accountType: '口座種類2',
//            accountNumber: '口座番号2',
//            accountName: '名義2',
//            targetPerson: 'テスト相続人2',
//            inheritanceBequest: '相続'
//        },
//        {
//            depositSaving: '1000000',
//            bankName: '銀行名3',
//            branchName: '支店名3',
//            accountType: '口座種類3',
//            accountNumber: '口座番号3',
//            accountName: '名義3',
//            targetPerson: 'テスト相続人3',
//            inheritanceBequest: '相続'
//        }
    ]
};

const slice = createSlice({
    name: 'deposit',
    initialState,
    reducers: {
        setDeposit: (state, action) => {
            return Object.assign({}, state, { deposit: state.deposit.concat(action.payload) })
        },
        clearDeposit: (state, action) => {
            const newArray = Array.from(new Set([...state.deposit]));
            newArray.splice(action.payload, 1)
            return Object.assign({}, state, { deposit: newArray })
        },
    }
});


export default slice.reducer;

export const {
    setDeposit,
    clearDeposit,
} = slice.actions;
